// tslint:disable
export enum TCSEligibilityStatus {
    /**
     * @description Unknown
     */
    Unknown = -1,
    /**
     * @description Member number valid, but patient ineligible at this time
     */
    PatientIneligible = 0,
    /**
     * @description Eligible pending survey data
     */
    EligiblePending = 1,
    /**
     * @description Pending enrollment
     */
    PendingEnrollment = 2,
    /**
     * @description Member number invalid
     */
    MemberNumberInvalid = 3,
    /**
     * @description Activation period expired
     */
    ActivationPeriodExpired = 4,
    /**
     * @description Ready to activate
     */
    ReadyToActivate = 5,
    /**
     * @description Transfer to TrialCard
     */
    TransferToTrialcard = 6,
}
(TCSEligibilityStatus as any)['UNKNOWN'] = -1;
(TCSEligibilityStatus as any)['PATIENTINELIGIBLE'] = 0;
(TCSEligibilityStatus as any)['ELIGIBLEPENDING'] = 1;
(TCSEligibilityStatus as any)['PENDINGENROLLMENT'] = 2;
(TCSEligibilityStatus as any)['MEMBERNUMBERINVALID'] = 3;
(TCSEligibilityStatus as any)['ACTIVATIONPERIODEXPIRED'] = 4;
(TCSEligibilityStatus as any)['READYTOACTIVATE'] = 5;
(TCSEligibilityStatus as any)['TRANSFERTOTRIALCARD'] = 6;
